import { useMemo } from "react";
import { useTheme } from "@fluentui/react/lib/Theme";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  root: `EditRoot`
};

export function useEditStyles() {
  const { spacing } = useTheme();
  return useMemo(
    () => mergeStyleSets({
      root: [
        classNames.root,
        {
          height: `100%`,
          marginTop: spacing.l1,
          overflowY: `scroll`,
          paddingBottom: `22px`,
          paddingRight: `15px`
        }
      ]
    }),
    [spacing]
  );
}
